<app-menu-template3 *ngIf="authService.getTipoUser() !== tipo_administrador_cc || authService.getTipoUser() !== tipo_administrador_super">
  <ng-container *ngTemplateOutlet="ruta_no_exite"></ng-container>
</app-menu-template3>
<app-side-menu1 *ngIf="authService.getTipoUser() === tipo_administrador_cc || authService.getTipoUser() === tipo_administrador_super">
  <ng-container *ngTemplateOutlet="ruta_no_exite"></ng-container>
</app-side-menu1>

<ng-template #ruta_no_exite>
  <main class="container mb-3 bg-white mt-3 p-5 shadow-sm">
    <section class="row text-center">
      <header class="col-12">
        <figure class="figure w-100">
          <img class="img-fluid mb-4" src="../../../../../../../assets/images/en-construccion.png" />
          <figcaption>
            <label class="h4 text-secondary">Pagina en contrucción</label>
            <br>
            <label for="h6 text-secondary"> Versión: {{version}}</label>
          </figcaption>
        </figure>
      </header>
    </section>
  </main>

</ng-template>